import { FC, useState } from 'react';
import Field from '../../components/shared/Field/Field';
import Modal from '../../components/shared/Modal/Modal';
import { NotificationManager } from 'react-notifications';
import { ServiceAuth } from '../../services/service-auth';
import { validateEmail } from '../../util';
import { useTranslation } from 'react-i18next';

type Props = {
  initialEmail: string,
  show: boolean,
  setShow: (show : boolean) => void,
}

const ForgotPassword : FC<Props> = ({initialEmail, show, setShow}) => {
  const [t] = useTranslation('login');
  const [email, setEmail] = useState(initialEmail);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState('');

  const sendPasswordResetEmail = async () => {
    const trimmedEmail = email.trim();
    if (validateEmail(trimmedEmail) !== '') {
      setEmailError(
        trimmedEmail
          ? t('changePassword.validation.syntax', 'Ogiltig e-postadress')
          : t('changePassword.validation.empty', 'Du måste fylla i e-postadress')
      );
      return;
    }
    setLoading(true);
    try {
      await ServiceAuth.forgotPassword(trimmedEmail);
      NotificationManager.success(
        t('changePassword.notification.success.description', 'En länk för att återställa lösenordet har skickats till din e-post'),
        t('changePassword.notification.success.title', 'Skickat')
      );
      setLoading(false);
      setShow(false);
    } catch (e) {
      setLoading(false);
      NotificationManager.error(
        t('changePassword.notification.error.description', 'Det finns inget konto med den angivna informationen.'),
        t('changePassword.notification.error.title', 'Inget konto hittades')
      );
    }
  };

  const onChange = (value : string) => {
    setEmailError('');
    setEmail(value);
  };

  return (
    <Modal 
      title={t('changePassword.title','Återställ ditt lösenord')}
      show={show} 
      setShow={setShow}
      buttonInfo={{label: t('changePassword.send','Skicka'), action: sendPasswordResetEmail, loaderShow: loading}}
    >
      <div style={{maxWidth:'600px'}} className="custom-forgot-modal">
        <div className="forgot-modal-description">
          {t('changePassword.description', 'Fyll i den e-postadress du använde när du registrerade dig så skickar vi e-post med en länk du kan använda för att återställa ditt lösenord.')}
        </div>

        <Field 
          type="email" 
          errorMessage={emailError}
          label={t('eMail','E-post')} 
          value={email}
          onChange={onChange} 
        />
      </div>
    </Modal>
  );
}

export default ForgotPassword;
